import { z } from 'zod';
import { fleetRecoverySha256Schema as hash, fleetRecoveryUuidSchema as uuid,
  fleetRecoveryIdSchema as id, fleetRecoveryUint64Schema as uint64, fleetRecoveryUtcSchema as utc } from '../fleetRecoverySchemas';
import { signedRecoveryBaselineTemplateV1Schema } from './baselineTemplateSchemas';
import { recoveryPromotionProofV1Schema,recoveryReservedCandidateProofV1Schema } from './releaseEligibilitySchemas';
export * from './baselineTemplateSchemas';
export const recoveryBaselineKindV1Schema = z.enum(['replace-updater', 'replace-rescue', 'force-reboot']);
export const recoveryCapsulePayloadV1Schema = z.object({ schemaVersion: z.literal(1), keyId: id,
  issuedAtUtc: utc, expiresAtUtc: utc, correlationId: uuid, kind: recoveryBaselineKindV1Schema,
  template: signedRecoveryBaselineTemplateV1Schema.nullable(),
  eligibility: z.union([recoveryPromotionProofV1Schema,recoveryReservedCandidateProofV1Schema]).nullable(),
}).strict().superRefine((payload, ctx) => {
  const duration = Date.parse(payload.expiresAtUtc) - Date.parse(payload.issuedAtUtc);
  if (duration <= 0 || duration > 60000 || (payload.kind === 'force-reboot' ? payload.template !== null || payload.eligibility !== null
    : !payload.template || !payload.eligibility || payload.template.payload.kind !== payload.kind))
    ctx.addIssue({ code: 'custom', message: 'Invalid capsule admission authority' });
});
export type RecoveryCapsulePayloadV1 = z.infer<typeof recoveryCapsulePayloadV1Schema>;
export const recoveryCapsulePollV1Schema = z.object({ bootId: id, generation: uint64,
  admittedCapsuleSha256: hash.optional(),
  hardwareIdSha256: hash.optional(),
  architecture: z.enum(['x64', 'arm64']), updaterSha256: hash, rescueSha256: hash, baselineSha256: hash }).strict();
export type RecoveryCapsulePollV1 = z.infer<typeof recoveryCapsulePollV1Schema>;
